if (!customElements.get('waste-guide')) {
  customElements.define('waste-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.search = this.querySelector('[data-guide-search]');
      this.cards = [...this.querySelectorAll('[data-guide-card]')];
      this.exceptions = [...this.querySelectorAll('[data-guide-exception]')];
      this.filters = [...this.querySelectorAll('[data-guide-filter]')];
      this.status = this.querySelector('[data-guide-status]');
      this.group = 'all';
      this.cards.forEach(card => {
        card.searchText = this.normalize(card.dataset.searchTerms);
        card.wasteName = this.normalize(card.querySelector('h2').textContent);
      });
      this.exceptions.forEach(item => {
        item.searchTerms = item.dataset.searchTerms.split(',').map(term => this.normalize(term)).filter(Boolean);
      });
      this.search.addEventListener('input', () => this.update());
      this.filters.forEach(button => button.addEventListener('click', () => {
        this.group = button.dataset.guideFilter;
        this.update();
      }));
      this.querySelector('[data-guide-reset]').addEventListener('click', () => {
        this.search.value = '';
        this.group = 'all';
        this.update();
        this.search.focus();
      });
      this.querySelector('[data-guide-controls]').hidden = false;
    }

    normalize(value) {
      return value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-]/g, ' ').replace(/\s+/g, ' ').trim();
    }

    update() {
      const query = this.normalize(this.search.value);
      const words = query.split(' ').filter(Boolean);
      let adviceCount = 0;
      this.exceptions.forEach(item => {
        // A whole material name must occur; short fragments must not trigger unrelated advice.
        const matches = query.length > 1 && item.searchTerms.some(term => (` ${query} `).includes(` ${term} `));
        item.hidden = !matches;
        if (matches) adviceCount++;
      });
      let count = 0;
      this.cards.forEach(card => {
        const matchesGroup = this.group === 'all' || card.dataset.guideGroup === this.group;
        const matchesSearch = words.every(word => card.searchText.includes(word));
        card.hidden = adviceCount > 0 || !matchesGroup || !matchesSearch;
        if (!card.hidden) count++;
      });
      // Show a named waste stream before broader mixed-waste alternatives.
      const orderedCards = [...this.cards].sort((a, b) => {
        const aNamed = words.length > 0 && words.every(word => a.wasteName.includes(word));
        const bNamed = words.length > 0 && words.every(word => b.wasteName.includes(word));
        return Number(bNamed) - Number(aNamed);
      });
      this.querySelector('.waste-guide__grid').append(...orderedCards);
      this.filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.guideFilter === this.group)));
      this.querySelector('[data-guide-advice]').hidden = adviceCount === 0;
      this.querySelector('[data-guide-empty]').hidden = count > 0 || adviceCount > 0;
      this.status.textContent = adviceCount > 0
        ? this.querySelector('[data-guide-advice] h2').textContent
        : this.status.dataset.resultTemplate.replace('[count]', count);
    }
  });
}
